<script setup lang="ts">
    /**
     * Text Slider Widget Container
     * displays a set of text blocks to be rendered as a carousel
     * has an option intro component to render at the top
     *
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/606208030
     */
    const props = defineProps<IWidgetProps<TextSliderData>>();
    const { data, getValueSequence, cmsComponentProps } = useWidget(props);

    // validate data here and perform additional async calls if required
    const sequence = getValueSequence(data.value);
</script>
<template>
    <org-text-slider
        :sequence="sequence"
        v-bind="cmsComponentProps" />
</template>
